<template>
  <div>  
  <!--================ Offer section start =================-->      
  <section class="section-margin">
    <div class="container">
      <div class="section-intro pb-85px text-center">
        <h2 class="section-intro__title">Solution for telecom & mobile</h2>
        <p class="section-intro__subtitle">
            <b>The problem</b><br>
            When the user decide to change or cancel the mobile subscription they are directed to call to the customer support.
            And then the agents work is to persuade the user to stay with diffrent discounts.
            The problem with this is that often there is a long queue, and you need to speak to a agent that is trying to persuade you.
            This is very frustrating and decreases the customer loyalty. 
            <br><br>
            <b>The solution</b><br>
            With RetainerDesk you can automate this process by having a cancel button on your website. Where to user is directed to the cancelletion checkout.
            There they will be met with offers and if they decied to cancel you'll have the data on who and why they cancelled.
            If they take a offer the customer loyalty will increase and their experience with you as an operator will skyrocket.
        </p>
      </div>

      <div class="row">
        <div class="col-lg-6">

          <div class="row offer-single-wrapper">
            <div class="col-lg-6 offer-single">
              <div class="card offer-single__content text-center">
                <span class="offer-single__icon">
                  <i class="ti-wand"></i>
                </span>
                <h4>Cancelletion checkout</h4>
                <p>If a customer want to cancel their subscription they will go through the Retention Flow, where we gather data on why they want to cancel.</p>
              </div>
            </div>
            
            <div class="col-lg-6 offer-single">
              <div class="card offer-single__content text-center">
                <span class="offer-single__icon">
                  <i class="ti-signal"></i>
                </span>
                <h4>Motivate</h4>
                <p>In the cancelletion checkout you have the opportunity to persuade the user to stay with your solutin with downgrade or discounts.</p>
              </div>
            </div>
          </div>

          <div class="row offer-single-wrapper">
            <div class="col-lg-6 offer-single">
              <div class="card offer-single__content text-center">
                <span class="offer-single__icon">
                  <i class="ti-na"></i>
                </span>
                <h4>Cancel button</h4>
                <p>As an option you can add a cancel button to your webpage where the user will be redirected to the cancel checkout</p>
              </div>
            </div>
            
            <div class="col-lg-6 offer-single">
              <div class="card offer-single__content text-center">
                <span class="offer-single__icon">
                  <i class="ti-link"></i>
                </span>
                <h4>Cancel link</h4>
                <p>If you would like to do it manually it is possible to send out cancellation links that redirects the user to the cancel checkout</p>
              </div>
            </div>
          </div>

        </div>
        <div class="col-lg-6">
            <div class="offer-single__img" style="box-shadow: 0px 3px 15px -9px rgba(0,0,0,0.75); margin-top:50px;">
                    <img class="img-fluid" style="margin-top:-5px; padding:0px; width:102%;" src="@/assets/top_safar_retainerdesk.png" alt="">
                    <img class="img-fluid" style="margin-top:7%;" src="@/assets/retainer_video.gif" alt="">
            </div>
        </div>
      </div>
    </div>
  </section>
  <!--================ Offer section end =================-->

      <!--================ about section start =================-->      
    <section class="section-padding--small bg-magnolia">
      <div class="container">
        <div class="row">
          <div class="col-md-5 mb-5 mb-md-0">
            <div class="solution__content">
              <h2>Why use RetainerDesk?</h2>
              <p>
                You might ask your self, why don't we develop this ourselfs? The simple answer to that question is:<br> <b>data and machine learning.</b>
                <br><br>Your users will have most converting and best in class cancelletion experience, which in return creates less churns over time.
                <br><br>Our solution can also be on premise in your serverhall.

              </p>
              <a class="button button-light button-blue" href="/pricing">Choose Your Plan</a>
            </div>
          </div>
          <div class="col-md-7">
            <div class="offer-single__img">
                <img class="img-fluid" style="width:75%; height:auto;" src="@/assets/mobile-devices-2017980_1280.png" alt="">
            </div>
          </div>
        </div>
        

      </div>
    </section>
        <section class="section-padding--small bg-white">
      <div class="container">

            <div class="section-intro pb-5 text-center" style="">
          <h2 class="section-intro__title">Try RetainerDesk for free today!</h2>
          <p class="section-intro__subtitle">14 day free trial - cancel anytime - No credit card required</p>
          <br>
          <a class="button button-light button-blue" href="https://app.retainerdesk.com/#/register">Try it free</a>

        </div>
      </div>
    </section>    


    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>